/**
 * AutoResolveToast - Shows notifications when work items are auto-resolved
 *
 * Listens for 'work-items-resolved' events from the API layer and displays
 * toast notifications that auto-dismiss after 5 seconds.
 */
import React, { useEffect, useState } from 'react';
import { CheckCircle, X } from 'lucide-react';

function AutoResolveToast() {
  const [resolved, setResolved] = useState([]);

  useEffect(() => {
    const handler = (e) => {
      const newItems = e.detail || [];
      if (newItems.length === 0) return;

      setResolved(prev => [...prev, ...newItems]);

      // Auto-dismiss after 5 seconds
      setTimeout(() => {
        setResolved(prev => prev.slice(newItems.length));
      }, 5000);
    };

    window.addEventListener('work-items-resolved', handler);
    return () => window.removeEventListener('work-items-resolved', handler);
  }, []);

  if (resolved.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2 max-w-sm">
      {resolved.map((item, idx) => (
        <div
          key={`${item.id}-${idx}`}
          className="bg-green-50 border border-green-200 rounded-lg p-4 shadow-lg flex items-start gap-3 animate-fade-in"
        >
          <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-green-800">
              Tache resolue automatiquement
            </p>
            <p className="text-sm text-green-600 mt-1 truncate">
              {item.resolution_note || item.title}
            </p>
          </div>
          <button
            onClick={() => setResolved(prev => prev.filter((_, i) => i !== idx))}
            className="text-green-400 hover:text-green-600 flex-shrink-0"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
}

export default AutoResolveToast;
